import { useEffect } from 'react';
import { AlertTriangle, X } from 'lucide-react';

export default function ConfirmDialog({
  open,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'danger',
  onConfirm,
  onCancel,
}) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  if (!open) return null;

  const variantStyles = {
    danger: {
      icon: 'text-neon-pink',
      confirmBtn:
        'bg-neon-pink/20 text-neon-pink border border-neon-pink/40 hover:bg-neon-pink/30 hover:shadow-neon-pink',
      glow: 'shadow-neon-pink',
    },
    warning: {
      icon: 'text-neon-amber',
      confirmBtn:
        'bg-neon-amber/20 text-neon-amber border border-neon-amber/40 hover:bg-neon-amber/30 hover:shadow-neon-amber',
      glow: 'shadow-neon-amber',
    },
  };

  const styles = variantStyles[variant] || variantStyles.danger;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-dialog"
        onClick={onCancel}
      />

      {/* Dialog */}
      <div
        className={`relative w-full max-w-md rounded-2xl border border-surface-600 bg-surface-800 p-6 ${styles.glow}`}
      >
        {/* Close button */}
        <button
          onClick={onCancel}
          className="absolute top-4 right-4 rounded-lg p-1 text-slate-400 hover:bg-surface-700 hover:text-slate-200 transition-colors"
        >
          <X size={18} />
        </button>

        {/* Icon */}
        <div className="mb-4 flex justify-center">
          <div className={`rounded-full bg-surface-700 p-3 ${styles.icon}`}>
            <AlertTriangle size={28} />
          </div>
        </div>

        {/* Content */}
        <h3 className="mb-2 text-center text-lg font-bold text-slate-100">
          {title}
        </h3>
        <p className="mb-6 text-center text-sm text-slate-400">{message}</p>

        {/* Actions */}
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 rounded-xl border border-surface-600 bg-surface-700 px-4 py-2.5 text-sm font-semibold text-slate-300 hover:bg-surface-600 hover:text-slate-100 transition-all"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className={`flex-1 rounded-xl px-4 py-2.5 text-sm font-semibold transition-all ${styles.confirmBtn}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
